<template>
  <el-row>
    <div id="breadcrumb" style="display: block;">
      <el-breadcrumb separator="/" class="admincrumb">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>店铺</el-breadcrumb-item>
        <el-breadcrumb-item>购物详情标签</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div id="toolbar" style="display: block; text-align: right;">
      <el-form :inline="true" :model="sData" name="squery" ref="squery" class="form-inline">
        <el-form-item label="搜索条件">
          <el-input v-model="sData.tabName" required placeholder="请输入搜索关键词"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button-group>
            <el-button type="primary"><i class="el-icon-search" style="font-weight: bolder; margin-right: 6px;"></i>搜索标签项</el-button>
            <el-button type="primary" @click="addshow = true"><i class="fa fa-plus" style="font-weight: bolder; margin-right: 6px;"></i>新增标签项</el-button>
          </el-button-group>
        </el-form-item>
      </el-form>
    </div>
    <el-row>
      <el-col span="10">
        <el-table :data="tbPage" v-loading="pageloading" element-loading-text="拼命加载中..." element-loading-spinner="el-icon-loading" stripe>
          <el-table-column prop="ID" label="编号"></el-table-column>
          <el-table-column prop="tabName" label="名称"></el-table-column>
          <el-table-column prop="state" label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.state">可用</span>
              <span v-else>不可用</span>
            </template>
          </el-table-column>
          <el-table-column label="标签管理">
            <template slot-scope="scop">
              <el-button-group>
              <el-button type="text" size="small" style="margin-right: 8px;" @click="voteForEdit(scop.row)">编辑</el-button>
              <el-button type="text" size="small" style="margin-right: 8px;" @click="removeShoppingTab(scop.row)">删除</el-button>
              <el-button type="text" size="small" @click="exStateShoppingTab(scop.row)">
                <span v-if="scop.row.state">启用</span>
                <span v-else>禁用</span>
              </el-button>
            </el-button-group>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col span="14" style="padding-left: 22px;">
        <el-form :model="curredit" name="editForm" ref="editForm">
          <el-form-item label="标签名称" :rules="{required: true, message: '标签名称不能为空', trigger: 'blur'}">
            <el-input v-model="curredit.tabName" placeholder="请输入标签名称"></el-input>
          </el-form-item>
          <el-form-item label="标签内容" prop="tabContant" :rules="{required: true, message: '标签内容不能为空', trigger: 'blur'}">
          <quill-editor :content="curredit.tabContant" ref="adseditor" v-model="addData.tabContant" rows="3" :options="editorOption"></quill-editor>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" @click="upShoppingTab('editForm')"><i class="fa fa-cloud-upload"></i>更新购物须知</el-button>
        </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-pagination
        @current-change="loadPage"
        :current-page="currShoppingTabPage.page"
        :page-sizes="[15]"
        :page-size="15"
        layout="total, sizes, prev, pager, next, jumper"
        :total="currShoppingTabPage.total">
      </el-pagination>
    </el-row>
    <el-dialog :visible.sync="addshow">
      <el-form :model="addData" name="addForm" ref="addForm">
        <el-form-item label="标签名称" prop="tabName" :rules="{required: true, message: '标签名称不能为空', trigger: 'blur'}">
          <el-input v-model="addData.tabName" placeholder="请输入标签名称"></el-input>
        </el-form-item>
        <el-form-item label="标签内容" prop="tabContant" :rules="{required: true, message: '标签内容不能为空', trigger: 'blur'}">
          <quill-editor :content="addData.tabContant" ref="adseditor" v-model="addData.tabContant" rows="3" :options="editorOption"></quill-editor>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" @click="handleTab('addForm')"><i class="fa fa-cloud-upload"></i>申请标签项</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </el-row>
</template>

<script>
export default {
  name: 'ShoppingTabs',
  data () {
    return {
      sData: {},
      addshow: false,
      addData: {},
      upurl: this.$apiurl,
      uploadattr: {method: 'base.upload'},
      tbContent: '',
      editorOption: {},
      load: '',
      currShoppingTabPage: {page: 1, 'total': 0},
      pageloading: false,
      tbPage: [],
      curredit: {}
    }
  },
  mounted () {
    this.loadPage(1)
  },
  methods: {
    hasloaded: function () {
      this.load.close()
      this.load = ''
    },
    fullLoad () {
      this.load = this.$loading({
        lock: true,
        text: '请求处理中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
    },
    handleTab: function (formname) {
      var that = this
      that.$refs[formname].validate(valid => {
        if (valid) {
          var para = that.addData
          para.method = 'shop.addshoptabs'
          that.fullLoad()
          that.$http.post(that.$apiurl, para).then(function (ret) {
            that.hasloaded()
            if (ret.body.data.code === 200) {
              this.$message.success('购物标签更新成功!')
              that.loadPage(1)
            } else {
              this.$alert('购物标签更新失败，请稍后重试!')
            }
          })
        }
      })
    },
    getHtml: function () {
      console.log(this.tbContent)
    },
    editChange: function () {
      this.getHtml()
    },
    loadPage: function (page) {
      var that = this
      var para = {}
      para.method = 'shop.shoptabList'
      para.num = 15
      para.page = page
      Object.assign(para, that.sData)
      that.pageloading = true
      that.$http.post(that.$apiurl, para).then(function (ret) {
        var curr = ret.body.data
        that.currShoppingTabPage.page = page
        that.currShoppingTabPage.total = curr.total
        that.tbPage = curr.data
        that.pageloading = false
      })
    },
    voteForEdit: function (row) {
      this.curredit = row
    },
    removeShoppingTab: function (row) {
      var that = this
      var para = {}
      para.method = 'shop.removeshoprabs'
      para.tabId = row.ID
      that.fullLoad()
      that.$http.post(that.$apiurl, para).then(function (ret) {
        that.hasloaded()
        if (ret.body.data.code === 200) {
          this.$message.success('购物标签删除成功!')
          that.loadPage(that.currShoppingTabPage.page)
        } else {
          this.$alert('购物标签删除失败，请稍后重试!')
        }
      })
    },
    exStateShoppingTab: function (row) {
      var that = this
      var para = {}
      para.method = 'shop.exshoptabsstate'
      para.tabId = row.ID
      that.fullLoad()
      that.$http.post(that.$apiurl, para).then(function (ret) {
        that.hasloaded()
        if (ret.body.data.code === 200) {
          this.$message.success('购物标签删除成功!')
          that.loadPage(that.currShoppingTabPage.page)
        } else {
          this.$alert('购物标签删除失败，请稍后重试!')
        }
      })
    },
    upShoppingTab: function (formname) {
      var that = this
      that.$refs[formname].validate(valid => {
        if (valid) {
          var para = that.curredit
          para.method = 'shop.updateshoptab'
          para.tabId = that.curredit.ID
          that.fullLoad()
          that.$http.post(that.$apiurl, para).then(function (ret) {
            that.hasloaded()
            if (ret.body.data.code === 200) {
              this.$message.success('购物标签更新成功!')
              that.loadPage(that.currShoppingTabPage.page)
            } else {
              this.$alert('购物标签更新失败，请稍后重试!')
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/shop/ShoppingTabs.vue